import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {User} from "../../../shared/interface/user";


export interface LicenseAddDialogData {
  user?: User;
}

@Component({
  selector: 'app-license-add-dialog',
  templateUrl: './license-add-dialog.component.html',
  styleUrls: ['./license-add-dialog.component.scss']
})
export class LicenseAddDialogComponent implements OnInit {
  userObject?: User = null;

  constructor(
    public dialogRef: MatDialogRef<LicenseAddDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: LicenseAddDialogData,
  ) {
    this.userObject = data?.user;
  }

  ngOnInit(): void {
  }
  closeDialog(e): void {
    this.dialogRef.close(e);
  }
}
